<!-- 多图片上传组件 -->
<template>
	<div class="hp uploadBox" :class="{ hide: !isHeadShow }">
		<el-upload
			:action="action"
			:list-type="listType"
			:file-list="fileList"
			:core-prop="coreProp"
			multiple
			drag
			:on-preview="onPreview"
			:on-remove="onRemove"
			:on-success="onSuccess"
			:before-upload="beforeUpload"
			:on-exceed="onExceed"
			:accept="accept"
			:limit="limit"
			:limit-size="limitSize"
			v-if="isHeadShow"
			:data="data"
			:flag="flag"
			:headers="headers"
		>
			<i class="el-icon-upload" style="font-size: 70px;"></i>
			<div class="el-upload__text"><em>点击上传并导入</em></div>
			<div class="el-upload__tip" slot="tip">{{ desc }}</div>
		</el-upload>
		<el-upload v-else :action="action" :list-type="listType" :file-list="fileList" :core-prop="coreProp" :limit-size="limitSize" :on-preview="onPreview"></el-upload>
		<el-dialog title="图片预览" custom-class="customDialog" append-to-body :visible.sync="dialogVisible"><img :src="dialogImageUrl" /></el-dialog>
	</div>
</template>

<script>
//附件操作api
import ATT_API from '@/api/api_att';
import ElUploadE from './elUploadE';
import API from '@/api/HotWork/hot_work_apply';

export default {
	name: 'uploadMultiple',
	components: { ElUploadE },
	props: {
		uploadVisible: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		//文件上传的url
		action: {
			type: String,
			default: () => {
				return process.env.API_ROOT + '/api-cms/riskControl/importFromFile';
			}
		},
		//图片列表类型
		listType: {
			type: String,
			default: () => {
				return;
				('picture');
			}
		},
		//限制上传的文件数量
		limit: {
			type: Number,
			default: () => {
				return 10;
			}
		},
		//文件列表
		fileList: {
			type: Array,
			default: () => {
				return [];
			}
		},
		//内置属性
		coreProp: {
			type: Object,
			default: () => {
				return {
					//该文件列表是否被改变过,如果被改变过则为true,反之为false
					isChange: false,
					//上传成功后的文件列表id
					fileIds: []
				};
			}
		},
		accept: {
			type: String,
			default: () => {
				return '';
			}
		},
		//限制文件上传大小,单位 M
		limitSize: {
			type: Number,
			default: () => {
				return 20;
			}
		},
		isHeadShow: {
			type: Boolean,
			default: () => {
				return true;
			}
		},
		data: {
			type: Object,
			default: () => {
				return {};
			}
		},
		flag: {
			//用于区分删除附件调用的方法
			type: String,
			default: () => {
				return 'default';
			}
		},
		headers: {
			type: Object,
			default: () => {
				return { Authorization: window.localStorage.getItem('access-token') };
			}
		}
	},
	data() {
		return {
			file: null,
			dialogVisible: false,
			dialogImageUrl: null,
			desc: '附件大小不能超过20M'
		};
	},
	mounted() {
		let text = '';
		// if(this.accept){
		//   text = '只能上传'+this.accept+'的Excel文件'
		// }
		// if(this.limitSize){
		//   if(text){
		//      text += "，";
		//   }
		//   text += "附件大小不能超过"+this.limitSize+"M";
		// }
		this.desc = text;
		if (!this.isHeadShow) {
			let elUpload = document.getElementsByClassName('el-upload');
		}
	},
	methods: {
		//文件上传成功触发函数
		onSuccess(res, file) {
			if (res.code === 0) {
				this.file = file;
				var msg = '';
				if (res.errorMessages.length > 0) {
					msg = res.errorMessages.join('*');
					this.$message.warning(msg);
				}
				else{
					msg = '成功导入 ' + res.successCount + ' 条员工数据';
					this.$message.success(msg);
				}
				//将id更新到业务对象中
        if(res.att) {
          this.coreProp.fileIds.push(res.att.id);
          //file 绑定id
          file.id = res.att.id;
          //文件被改变过
          this.coreProp.isChange = true;
          if (this.listType !== 'picture') {
          	let fileData = {
          		id: res.att.id,
          		name: res.att.name,
          		//url要加点料
          		url: process.env.API_ROOT + '/api-base' + res.att.url
          	};
          	this.fileList.push(fileData);
          }
        }
				this.$emit('onSuccess', res, file);
			} else {
				this.$message.error('上传失败');
			}
		},
		//预览函数
		onPreview(file) {
			//获取文件后缀名
			let suffix = '';
			let i = -1;
			//判断此文件是否为新上传的,如果是新上传的那么必有raw属性
			if (file) {
				if (file.raw) {
					i = file.raw.name.lastIndexOf('.');
					suffix = i > 0 ? file.raw.name.substring(i + 1).toLowerCase() : '';
				} else if (file.url) {
					i = file.url.lastIndexOf('.');
					suffix = i > 0 ? file.url.substring(i + 1).toLowerCase() : '';
				}
				let re = /(gif|jpg|jpeg|bmp|png|ico|tif)/g;
				if (re.test(suffix) && file.url) {
					//是图片
					this.dialogImageUrl = file.url;
					this.dialogVisible = true;
				} else if (!file.raw && file.url) {
					//只有不是最新上传的,且非图片就进行下载
					//下载文件
					window.location.href = file.url;
				}
			}
		},
		//文件删除触发函数
		onRemove(file, flist) {
			//获取该文件id
			if (file.id) {
				if (this.flag == this.$const.Activiti) {
					// API.delAttachmentById({
					// 	Id: file.id
					// }).then(res => {
					// 	if (res.code == 0) {
					// 		this.$message.success('删除成功');
					// 	} else {
					// 		this.$message.success('删除失败');
					// 	}
					// });
					//重新更新现有文件id列表
					this.coreProp.fileIds = flist.map(function(item) {
						return item.id;
					});
					//文件被改变过
					this.coreProp.isChange = true;
					this.fileList.forEach((o, i) => {
						if (file.id == o.id) {
							//处理fileList数组,删除指定项
							this.fileList.splice(i, 1);
							//终止循环
							return false;
						}
					});
				} else {
					// ATT_API.delAttById({
					// 	id: file.id
					// }).then(res => {
					// 	if (res.code == 0) {
					// 		this.$message.success('删除成功');
					// 	} else {
					// 		this.$message.success('删除失败');
					// 	}
					// });
					//重新更新现有文件id列表
					this.coreProp.fileIds = flist.map(function(item) {
						return item.id;
					});
					//文件被改变过
					this.coreProp.isChange = true;
					this.fileList.forEach((o, i) => {
						if (file.id == o.id) {
							//处理fileList数组,删除指定项
							this.fileList.splice(i, 1);
							//终止循环
							return false;
						}
					});
				}
			}

			this.$emit('onRemove', file, flist);
		},
		//文件上传前处理函数
		beforeUpload(file) {
			const isLt2M = file.size / 1024 / 1024 < this.limitSize;

			if (!isLt2M) {
				this.$message.error('上传文件大小不能超过 ' + this.limitSize + 'MB!');
				return false;
			}

			if (this.accept && file.name) {
				//转换为小写
				let accepts = this.accept.toLowerCase().split(',');
				let fname = file.name.toLowerCase();
				let pass = false;
				accepts.forEach((suffix, i) => {
					if (fname.endsWith(suffix)) {
						pass = true;
						return pass;
					}
				});
				if (!pass) {
					this.$message.error('上传文件只能是[' + this.accept + ']格式的Excel文件!');
					return false;
				}
			}

			return true;
		},
		//选择文件超过删除限制个数触发函数
		onExceed(files, fileList) {
			//提示
			this.$message.error('最多只能上传' + this.limit + '个文件');
		}
	},
	watch: {}
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/ .customDialog {
		max-width: 1200px;
		max-height: 90%;
		width: auto;
		img {
			max-width: 100%;
			max-height: 100%;
		}
	}
}

.uploadBox {
	> div {
		height: 100%;
	}
	/deep/ .el-upload-list--picture {
		/*display: flex;*/
		/*align-items: flex-start;*/
		/*flex-wrap: wrap;*/
		height: calc(100% - 205px);
		overflow: auto;
		.el-upload-list__item {
			float: left;
			position: relative;
			width: auto;
			height: 117px;
			margin: 20px 20px 0 0;
			.el-upload-list__item-thumbnail {
				width: 95px;
				height: 95px;
				max-width: inherit;
			}
			.el-upload-list__item-name {
				position: absolute;
				z-index: 2;
				top: 0;
				right: 0;
				width: 100%;
				height: 100%;
				padding: 0;
				margin: 0;
				color: #5D8C82;
			}
			.el-upload-list__item-status-label {
				z-index: 3;
			}
			.el-icon-close {
				z-index: 4;
				top: 1px;
				right: 1px;
			}
		}
	}
	&.hide {
		/deep/ .el-icon-close {
			display: none !important;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/uploadEmpList.vue